import RejoinCallFloatingData from './RejoinCallFloatingButton.data';
export default RejoinCallFloatingData;
